import {
  Input,
  Select
} from '@oliasoft-open-source/react-ui-library';
import { DATE_FIELDS } from 'common/enums/entity-enums';
import {
  getEntityParameterEnumOptions, getEntityParameterEnums
} from '../query-utils';
import { ICondition } from 'common/interfaces/query';

interface IQueryConditionCell {
  item: ICondition;
  updateCondition: (index: number, changes: Partial<ICondition>) => void;
  index: number
}

export const QueryConditionCell = (
  {
    item, updateCondition, index
  }: IQueryConditionCell,
) => {
  const isSelect = getEntityParameterEnums(item.entityType, item.entityPropertyName);
  let selectOptions: { label: string, value: string }[] = [];
  if (isSelect) {
    selectOptions = getEntityParameterEnumOptions(item.entityType, item.entityPropertyName);
  }
  const isDate = DATE_FIELDS.some(field => item.entityPropertyName.includes(field));
  return isSelect
    ? (
      <Select
        value={item.conditionValue}
        options={selectOptions}
        name="conditionValue"
        onChange={(event) => updateCondition(index, { [event.target.name]: event.target.value })}
      />
    )
    : (
      <Input
        type={isDate ? 'date' : 'input'}
        value={item.conditionValue}
        name="conditionValue"
        onChange={(event) => updateCondition(index, { [event.target.name]: event.target.value })}
      />
    );
}